import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AddonDarkModeService, EnumAddonDarkMode } from '@domains/frontend/page-addons';
import { EnumNgFaSize } from '@libs/frameworks/angular';


@Component({
    selector: 'ui-dark-mode',
    templateUrl: './dark-mode.component.html',
    styleUrls: ['./dark-mode.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UiDarkModeComponent implements OnInit {
	@Input() appearance: 'dropdown' | 'toggle' = 'dropdown';

	//** UI Variables */
	darkMode	  : EnumAddonDarkMode = EnumAddonDarkMode.Light;
	appearanceMode: TypeUiAppearanceMode = 'system';

	//** Getter Helpers */
	readonly EnumAddonDarkMode: typeof EnumAddonDarkMode = EnumAddonDarkMode;
	readonly EnumNgFaSize	  : typeof EnumNgFaSize = EnumNgFaSize;
	readonly SYSTEM_MODE	  : TypeUiAppearanceMode = 'system';


	constructor(
		private darkModeService	: AddonDarkModeService,
		private changeDetectorRef: ChangeDetectorRef
	) {}


	ngOnInit(): void {

		// Keep both the resolved colour theme and the selected preference in sync.
		this.darkModeService.onModeChange((mode: EnumAddonDarkMode) => {
			this.darkMode = mode;
			this.appearanceMode = this.darkModeService.isAutoSystemThemeEnabled() ? this.SYSTEM_MODE : mode;
			this.changeDetectorRef.markForCheck();
		});
	}

	//** On theme change */
	onThemeChange(mode: EnumAddonDarkMode): void {
		this.darkMode = mode;
		this.appearanceMode = mode;
		this.darkModeService.setCustomMode(mode);
	}

	onSystemThemeChange(): void {
		this.appearanceMode = this.SYSTEM_MODE;
		this.darkModeService.setSystemMode();
	}

	getAppearanceIcon(): string {
		if (this.appearanceMode === this.SYSTEM_MODE) return 'desktop';
		return this.darkMode === EnumAddonDarkMode.Dark ? 'moon' : 'sun';
	}

	//** Toggle directly between the two supported application themes. */
	onThemeToggle(): void {
		this.onThemeChange(
			this.darkMode === EnumAddonDarkMode.Dark
				? EnumAddonDarkMode.Light
				: EnumAddonDarkMode.Dark
		);
	}
}

type TypeUiAppearanceMode = EnumAddonDarkMode | 'system';
